// extracted by mini-css-extract-plugin
module.exports = {"container":"PromoList_container_3ewRf","headline":"PromoList_headline_q5YKK"};